import BaseData from '../../../BaseData'
import unitConverter from '../../../../utils/unitConverter'

export default {
  extends: BaseData,
  data () {
    return {
      query: {
        siteIds: [],
        factorIds: [],
        isAuditCompleted: false // finished
      },
      unitProp: 'displayUnit',
      selectedFactors: [],
      dataList: []
    }
  },
  computed: {
    filterSites () {
      return this.sites.reduce((list, site) => {
        let siteDevices = site.siteDevices.filter(siteDevice => siteDevice.siteDeviceFactors.length > 0)

        if (siteDevices.length > 0) {
          list.push({
            id: site.id,
            name: site.name,
            siteDevices
          })
        }

        return list
      }, [])
    },
    filterSiteMap () {
      return this.filterSites.reduce((map, site) => {
        map[site.id] = site
        return map
      }, {})
    },
    formatFactorGroupMap () {
      return this.factorGroups.map(factorGroup => ({
        id: factorGroup.id,
        name: factorGroup.name,
        parentId: factorGroup.parentId
      })).reduce((map, factorGroup) => {
        map[factorGroup.id] = factorGroup
        return map
      }, {})
    },
    filterFactorMap () {
      let {factorMap} = this
      return this.filterSites.reduce((map, site) => site.siteDevices.reduce((map, siteDevice) => siteDevice.siteDeviceFactors.reduce((map, siteDeviceFactor) => {
        let {factorId} = siteDeviceFactor

        if (!map[factorId]) {
          let factor = factorMap[factorId]
          map[factorId] = {
            id: factorId,
            name: factor.name,
            parentId: factor.parentId
          }
        }

        return map
      }, map), map), {})
    },
    filterFactors () {
      return Object.values(this.filterFactorMap)
    },
    factorTree () {
      let {filterFactors} = this
      let factorGroupMap = JSON.parse(JSON.stringify(this.formatFactorGroupMap))
      let roots = []

      for (let i = 0; i < filterFactors.length; i++) {
        let factor = filterFactors[i]
        let {parentId} = factor
        let parent = factorGroupMap[parentId]

        if (parent && parentId !== 'm30000') {
          let {children} = parent

          if (!Array.isArray(children)) {
            children = parent.children = []
            filterFactors.splice(i + 1, 0, parent)
          }

          children.push(factor)
        } else {
          roots.push(factor)
        }
      }

      return roots
    },
    canNotSearch () {
      let {query} = this
      return query.siteIds.length === 0 || query.factorIds.length === 0
    }
  },
  methods: {
    onSitesChanged () {
      let {filterSites, factorTree, query: {siteIds, factorIds}} = this

      if (filterSites.length > 0 && siteIds.length === 0) {
        siteIds.push(filterSites[0].id)
      }

      if (factorTree.length > 0 && factorIds.length === 0) {
        let firstFactorGroup = factorTree[0]
        let children = firstFactorGroup.children

        if (Array.isArray(children)) {
          let tmp = [...children]

          for (let i = 0; i < tmp.length; i++) {
            let factor = tmp[i]
            let children = factor.children

            if (Array.isArray(children)) {
              tmp.push(...children)
              continue
            }

            factorIds.push(factor.id)
          }

          this.$nextTick(() => {
            let factorTree = this.getFactorTree()

            if (factorTree) {
              factorTree.setCheckedKeys(factorIds)
            }

            factorIds = null
          })
        } else {
          factorIds.push(firstFactorGroup.id)
        }
      }

      if (!this.canNotSearch) {
        this.getData()
      }
    },
    getData () {
      let currentQuery = this.currentQuery = JSON.parse(JSON.stringify(this.query))
      let {factorIds} = currentQuery

      if (factorIds.indexOf('1012') === -1) {
        factorIds.push('1012')
      }

      if (factorIds.indexOf('1013') === -1) {
        factorIds.push('1013')
      }

      this.changeLoadStatus(true)
      this.$api.Data.getHistoryData(currentQuery).then(dataList => {
        this.tmpList = dataList
        this.setSelectedFactors()
        this.formatData()
        this.renderData()
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    setSelectedFactors () {
      let {factorMap} = this
      let {factorIds} = this.currentQuery
      this.selectedFactors = Object.freeze(factorIds.filter(factorId => factorId !== '1012' && factorId !== '1013').map(factorId => factorMap[factorId]))
    },
    formatData () {
      let {currentQuery, filterSiteMap, tmpList, factorMap, unitProp} = this
      let {siteIds} = currentQuery
      let dataMap = siteIds.reduce((map, siteId) => {
        map[siteId] = {
          siteId,
          siteName: filterSiteMap[siteId].name,
          data: {}
        }

        return map
      }, {})

      tmpList.reduce((map, tmpData) => {
        let siteData = map[tmpData.siteId]

        if (!siteData) {
          return map
        }

        let {dataTime} = tmpData
        siteData = siteData.data
        let valueMap = siteData[dataTime]

        if (!valueMap) {
          valueMap = siteData[dataTime] = {
            dataTime
          }
        }

        let {factorId} = tmpData
        let factor = factorMap[factorId]
        let {stdUnit, molecular, decimalNum} = factor
        let {value} = tmpData
        valueMap[factorId] = Number.isFinite(value) ? Number(unitConverter(value, stdUnit, factor[unitProp], molecular).toFixed(decimalNum)) : null

        return map
      }, dataMap)

      this.dataList = Object.freeze(Object.values(dataMap).map(data => ({
        siteId: data.siteId,
        siteName: data.siteName,
        data: Object.values(data.data)
      })))
    },
    renderData () {
      setTimeout(() => {
        (this.getRenderComponents() || []).forEach(component => component.render())
      }, 0)
    },
    onFactorCheckChange () {
      let checkedFactorList = this.getFactorTree().getCheckedNodes()
      this.query.factorIds = checkedFactorList.filter(item => !Array.isArray(item.children)).map(item => item.id)
    },
    onSearchBtnClick () {
      this.getData()
    },
    onAuditCompletedChanged () {
      let {query} = this
      if (query.isAuditCompleted === 'isFuse') {
        query.isFuse = true
        delete query.isAuditCompleted
      } else {
        query.isFuse = false
      }

      this.getData()
    },
    onUnitPropChange () {
      this.formatData()
      this.renderData()
    },
    getFactorTree () {
      return this.$refs['factor-tree']
    },
    getRenderComponents () {
      return this.$refs.charts
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/04Statistical-Analysis/03Pollution/01Meteorological/BaseMeteorological.js